import React, { ReactNode } from 'react';

export const gradeSVG: ReactNode = (
  <svg
    width="206"
    viewBox="0 0 206 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fill="#C02530" d="M0 0h40v32H0z" />
    <path
      d="M22.58 16.426v-1.47h-3.626V12.17h4.396V10.7h-6.09v9.8h1.694v-4.074h3.626Z"
      fill="#fff"
    />
    <path transform="translate(43)" fill="url(#a)" d="M0 0h38v32H0z" />
    <path
      d="M58.26 20.5h3.57c2.254 0 3.682-1.218 3.682-3.486V14.2c0-2.24-1.4-3.5-3.738-3.5H58.26v9.8Zm3.388-8.33c1.456 0 2.128.812 2.128 2.086v2.702c0 1.288-.616 2.072-2.114 2.072h-1.708v-6.86h1.694Z"
      fill="#fff"
    />
    <path transform="translate(84)" fill="url(#b)" d="M0 0h39v32H0z" />
    <path
      d="M103.746 20.64c2.03 0 3.374-1.176 3.472-3.262h-1.666c-.098 1.232-.728 1.792-1.904 1.792-1.33 0-2.016-.896-2.016-2.268v-2.576c0-1.4.686-2.296 2.03-2.296 1.176 0 1.764.616 1.89 1.792h1.666c-.14-1.932-1.344-3.262-3.598-3.262-2.198 0-3.71 1.302-3.71 3.71v2.674c0 2.408 1.498 3.696 3.836 3.696Z"
      fill="#fff"
    />
    <path transform="translate(126)" fill="url(#c)" d="M0 0h39v32H0z" />
    <path
      d="M142.26 20.5h3.64c1.932 0 3.29-.938 3.29-2.73v-.35c0-1.036-.532-1.736-1.498-2.1.658-.35 1.05-.91 1.05-1.694v-.364c0-1.666-1.176-2.562-3.262-2.562h-3.22v9.8Zm3.108-8.33c1.12 0 1.638.42 1.638 1.148v.294c0 .7-.518 1.162-1.596 1.162h-1.456V12.17h1.414Zm.392 3.976c1.134 0 1.694.49 1.694 1.288v.28c0 .784-.56 1.316-1.694 1.316h-1.806v-2.884h1.806Z"
      fill="#fff"
    />
    <path transform="translate(168)" fill="url(#d)" d="M0 0h38v32H0z" />
    <path
      d="M189.21 20.5h1.834l-3.486-9.8h-1.792l-3.5 9.8h1.778l.714-2.1h3.738l.714 2.1Zm-1.19-3.57h-2.814l1.414-4.158 1.4 4.158Z"
      fill="#fff"
    />
    <defs>
      <linearGradient
        id="a"
        x1=".707"
        y1="0"
        x2="38"
        y2="0"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CF4F30" />
        <stop offset=".495" stopColor="#E49040" />
        <stop offset="1" stopColor="#E49040" />
      </linearGradient>
      <linearGradient
        id="b"
        x1=".725"
        y1="0"
        x2="39"
        y2="0"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EBAF52" />
        <stop offset=".495" stopColor="#F1CD6B" />
        <stop offset="1" stopColor="#F6EB88" />
      </linearGradient>
      <linearGradient
        id="c"
        x1=".725"
        y1="0"
        x2="39"
        y2="0"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D0DE81" />
        <stop offset=".495" stopColor="#ACD07D" />
        <stop offset="1" stopColor="#89C07B" />
      </linearGradient>
      <linearGradient
        id="d"
        x1=".582"
        y1="0"
        x2="38"
        y2="0"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#68B179" />
        <stop offset=".49" stopColor="#48A078" />
        <stop offset="1" stopColor="#248F76" />
      </linearGradient>
    </defs>
  </svg>
);
